// src/components/faq/FaqCategoryNav.tsx
import React from 'react';
import {Button} from '@dopomogai/ui';
import clsx from 'clsx';

// Expecting an object of key-value pairs for categories from i18n
interface CategoryData {
  [key: string]: string;
}

interface FaqCategoryNavProps {
  categories: CategoryData;
  activeCategory: string;
  onSelectCategory: (category: string) => void;
}

export const FaqCategoryNav: React.FC<FaqCategoryNavProps> = ({
  categories,
  activeCategory,
  onSelectCategory,
}) => {
  if (!categories) return null;

  const categoryList = Object.entries(categories).map(([key, value]) => ({
    key,
    name: value,
  }));

  return (
    <nav className="bg-slate-100 py-4 border-y-2 border-slate-200 sticky top-[68px] z-20">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center justify-center gap-2">
          {categoryList.map((category) => {
            const isActive = activeCategory === category.key;
            return (
              <Button
                key={category.key}
                text={category.name}
                // 'secondary' for the active (filled) button, 'ghost' for others.
                variant={isActive ? 'secondary' : 'ghost'}
                size="sm"
                onClick={() => onSelectCategory(category.key)}
                // --- CORRECT IMPLEMENTATION ---
                // The Button component's `baseClasses` already include:
                // "hover:-translate-x-1 hover:-translate-y-1"
                // "active:translate-x-0 active:translate-y-0 active:shadow-none"
                // We just need to control WHEN the shadow appears.
                // The active button should have a persistent shadow.
                // The inactive buttons should only show a shadow on hover.
                className={clsx(
                  // If the button is active, give it a static shadow.
                  // The Button's own hover class will then slightly increase it.
                  isActive && "shadow-[2px_2px_0_0_black]",
                  // The Button component handles the rest of the hover/active effects automatically.
                )}
              />
            );
          })}
        </div>
      </div>
    </nav>
  );
};

